<script>
    import Service from "../utils/Service";

    export let config;

    const service = new Service(config.model_root);
    const user_defined_config = service.loadSystemConfig();
</script>

<div class="header">
    <div class="logo-container">
        <img src="../images/LOGO.JPG" alt="Logo" class="logo"/>
    </div>
    <div class="info-wrapper">
        {#await user_defined_config}
        {:then configdata}
            <div class="info-box">
                <strong><i class="fas fa-home"></i> Adresse:</strong>
                <span style="white-space: pre-line">{configdata.ADDRESS}</span>
                <span>www.dorfladen-gungolding.de</span>
            </div>
            <div class="info-box">
                <strong><i class="far fa-clock"></i> Öffnungszeiten:</strong>
                <span style="white-space: pre-line">{configdata.OPENING_HOURS}</span>
            </div>
        {/await}
    </div>
</div>

<style>
    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1px;
    }

    .logo-container {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .logo {
        max-width: 280px;
        height: auto;
    }

    .info-wrapper {
        flex: 2;
        display: flex;
        gap: 8px;
        justify-content: flex-end;
    }

    .info-box {
        flex: 1;
        border: 1px solid #c3c3c3;
        padding: 10px;
        text-align: center;
        font-size: 1rem;
        height: 100px; /* Einheitliche Höhe */
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .info-box strong {
        display: block;
        margin-bottom: 5px;
    }

    @media print {
        body {
            margin: 0;
            padding: 0;
        }

        .info-box {
            font-size: 0.9rem;
        }
    }
</style>
